import script from "./sunrise.vue?vue&type=script&setup=true&lang=ts"
export * from "./sunrise.vue?vue&type=script&setup=true&lang=ts"

import "./sunrise.vue?vue&type=style&index=0&id=6b90830d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b90830d"]])

export default __exports__